export default __webpack_public_path__ + "static/media/arrow-up.612d9769.svg";